// Auto generated file, do not manually modify!
// com.hotpads.adproducts.api.web.user.billing.handler.AdproductsUserBillingGetInvoicesApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { InvoiceListDto, InvoiceRequestDto } from '../..';

export const AdproductsUserBillingGetInvoicesApiHandler_getInvoices_Path =
  '/api/web/v1/users/billing/invoices/getInvoices';

/**
 * Get list of invoices
 */
export const AdproductsUserBillingGetInvoicesApiHandler_getInvoices = (
  postData: InvoiceRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, InvoiceRequestDto, InvoiceListDto>(
    {
      endpoint: AdproductsUserBillingGetInvoicesApiHandler_getInvoices_Path,
      method: 'POST',
      contextPath: '/adproducts',
      postData: postData,
    },
    client,
  );
};
